export function FormGroup({ children, className = '', spacing = 'default' }) {
  const spacingClasses = {
    tight: 'space-y-3',
    default: 'space-y-4',
    loose: 'space-y-6',
  }

  return (
    <div className={`${spacingClasses[spacing]} ${className}`}>{children}</div>
  )
}
